import { createContext, useContext, useState, useCallback } from "react";
import { translations } from "../i18n/translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("nlp_lang") || "en");

  const setLang = useCallback((l) => {
    localStorage.setItem("nlp_lang", l);
    setLangState(l);
  }, []);

  const t = useCallback(
    (key, vars) => {
      let str = (translations[lang] && translations[lang][key]) ?? translations.en[key] ?? key;
      if (vars) for (const k of Object.keys(vars)) str = str.replaceAll(`{${k}}`, vars[k]);
      return str;
    },
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>{children}</LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);
